<template>
	<SortableListAdder :invalid="invalid" @add="add">
		<LeaderboardForm class="form" v-model="toAdd" :ranges="ranges" />
	</SortableListAdder>
</template>

<script>
import { LeaderboardRange } from 'recycle-race-common/lib/enums'
import LeaderboardForm from '@/forms/LeaderboardForm'
import SortableListAdder from '@/components/SortableListAdder'

const DefaultSize = 10

export default {
	name: 'AddLeaderboardForm',
	props: {
		ranges: Array,
	},
	data() {
		return {
			toAdd: {
				name: '',
				range: '',
				limit: DefaultSize,
			},
		}
	},
	computed: {
		invalid() {
			const { range, limit } = this.toAdd
			return !(range in LeaderboardRange) || (limit !== null && limit < 1)
		},
	},
	methods: {
		add() {
			if (!this.invalid) {
				this.$emit('add', { ...this.toAdd })
				this.toAdd.name = ''
				this.toAdd.range = ''
				this.toAdd.limit = DefaultSize
			}
		},
	},
	watch: {
		ranges(next) {
			// If an existing range takes over range selected in this form,
			// reset selected range here
			if (this.toAdd.range !== '' && !next.includes(this.toAdd.range)) {
				this.toAdd.range = ''
			}
		},
	},
	components: {
		LeaderboardForm,
		SortableListAdder,
	},
}
</script>
